import { ActivationMethod, PolicyStatus } from '@/app/shared/enums';
import { ActivationModel } from '@/app/shared/models/insurance/activation.model';
import { Model } from '@/app/shared/models/model';

export class PolicyModel extends Model {
  public Id!: string;
  public Status?: PolicyStatus;
  public OurCode?: string;
  public Price?: number;
  public CurrencyCode?: string;
  public StartDate?: Date;
  public FinishDate?: Date | string;
  public CancelationDate?: Date;
  public CertificateUri?: string;
  public Created?: Date;
  public Updated?: Date;
  public Reason?: string;
  public ActivationMethod?: ActivationMethod;

  public Activations?: ActivationModel[];

  public PolicyForm?: [] &
    [
      {
        Id: string;
        Name: string;
      }
    ];
  public PolicyGroup?: [] &
    [
      {
        Id: string;
        Name: string;
      }
    ];
}
